// FILE: client/src/reducers/categoryReducers.js

import * as C from "../constants/categoryConstants";

const categoryListInitialState = {
  categories: [],
  page: 1,
  pages: 1,
  count: 0,
};

const categoryDetailsInitialState = {
  category: null,
};

export const categoryListReducer = (
  state = categoryListInitialState,
  action,
) => {
  switch (action.type) {
    case C.CATEGORY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined,
      };

    case C.CATEGORY_LIST_SUCCESS:
      return {
        loading: false,
        categories: action.payload?.categories || [],
        page: action.payload?.page || 1,
        pages: action.payload?.pages || 1,
        count: action.payload?.count || 0,
      };

    case C.CATEGORY_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case C.CATEGORY_LIST_RESET:
      return categoryListInitialState;

    case C.CATEGORY_CLEAR_ERROR:
      return {
        ...state,
        error: undefined,
      };

    default:
      return state;
  }
};

export const categoryDetailsReducer = (
  state = categoryDetailsInitialState,
  action,
) => {
  switch (action.type) {
    case C.CATEGORY_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined,
      };

    case C.CATEGORY_DETAILS_SUCCESS:
      return {
        loading: false,
        category: action.payload || null,
      };

    case C.CATEGORY_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case C.CATEGORY_DETAILS_RESET:
      return categoryDetailsInitialState;

    case C.CATEGORY_CLEAR_ERROR:
      return {
        ...state,
        error: undefined,
      };

    default:
      return state;
  }
};

export const adminCategoryListReducer = (
  state = categoryListInitialState,
  action,
) => {
  switch (action.type) {
    case C.ADMIN_CATEGORY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined,
      };

    case C.ADMIN_CATEGORY_LIST_SUCCESS:
      return {
        loading: false,
        categories: action.payload?.categories || [],
        page: action.payload?.page || 1,
        pages: action.payload?.pages || 1,
        count: action.payload?.count || 0,
      };

    case C.ADMIN_CATEGORY_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case C.ADMIN_CATEGORY_LIST_RESET:
      return categoryListInitialState;

    case C.ADMIN_CATEGORY_CLEAR_ERROR:
      return {
        ...state,
        error: undefined,
      };

    default:
      return state;
  }
};

export const adminCategoryDetailsReducer = (
  state = categoryDetailsInitialState,
  action,
) => {
  switch (action.type) {
    case C.ADMIN_CATEGORY_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined,
      };

    case C.ADMIN_CATEGORY_DETAILS_SUCCESS:
      return {
        loading: false,
        category: action.payload || null,
      };

    case C.ADMIN_CATEGORY_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case C.ADMIN_CATEGORY_DETAILS_RESET:
      return categoryDetailsInitialState;

    case C.ADMIN_CATEGORY_CLEAR_ERROR:
      return {
        ...state,
        error: undefined,
      };

    default:
      return state;
  }
};

export const adminCategoryCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case C.ADMIN_CATEGORY_CREATE_REQUEST:
      return {
        loading: true,
      };

    case C.ADMIN_CATEGORY_CREATE_SUCCESS:
      return {
        loading: false,
        success: true,
        category: action.payload || null,
      };

    case C.ADMIN_CATEGORY_CREATE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case C.ADMIN_CATEGORY_CREATE_RESET:
      return {};

    case C.ADMIN_CATEGORY_CLEAR_ERROR:
      return {
        ...state,
        error: undefined,
      };

    default:
      return state;
  }
};

export const adminCategoryUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case C.ADMIN_CATEGORY_UPDATE_REQUEST:
      return {
        loading: true,
      };

    case C.ADMIN_CATEGORY_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
        category: action.payload || null,
      };

    case C.ADMIN_CATEGORY_UPDATE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case C.ADMIN_CATEGORY_UPDATE_RESET:
      return {};

    case C.ADMIN_CATEGORY_CLEAR_ERROR:
      return {
        ...state,
        error: undefined,
      };

    default:
      return state;
  }
};

export const adminCategoryDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case C.ADMIN_CATEGORY_DELETE_REQUEST:
      return {
        loading: true,
      };

    case C.ADMIN_CATEGORY_DELETE_SUCCESS:
      return {
        loading: false,
        success: true,
        id: action.payload?.id,
      };

    case C.ADMIN_CATEGORY_DELETE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };

    case C.ADMIN_CATEGORY_DELETE_RESET:
      return {};

    case C.ADMIN_CATEGORY_CLEAR_ERROR:
      return {
        ...state,
        error: undefined,
      };

    default:
      return state;
  }
};
